import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import VStack from "shared/components/layout/stack/VStack";
import BlockHead from "shared/components/layout/heads/BlockHead";
import DropdownSingleSelectWithoutSearch from "shared/components/inputs/dropdown/DropdownSingleSelectWithoutSearch";
import { getDropdownOptions } from "features/admin/offices/OfficesForm";
import { OPTION_VARIANTS } from "shared/config/optionVariants";
import { sendNotification } from "shared/components/feedback/notification/notification";

import useAccessGroupLanding, {
    useLandingDefaultPage,
} from "features/admin/access-groups/single/useAccessGroupLanding";
import useAccessGroupApi from "features/admin/access-groups/single/useAccessGroup";

const notifyLandingPageSet = (modules, pageId, groupName) => {
    modules?.forEach((data) => {
        data?.pages?.forEach((page) => {
            if (page.id === pageId) {
                sendNotification(
                    <>
                        <strong>{page.name}</strong> set as Landing Page
                        for <strong>{groupName}</strong>
                    </>
                );
            }
        });
    });
};

const AccessGroupLanding = () => {
    const { groupId } = useParams();
    const { usePageDirectory } = useAccessGroupLanding();
    const { useAccessGroup } = useAccessGroupApi();
    const groupData = useAccessGroup(groupId);

    const { useDefaultPage, saveDefaultPage } = useLandingDefaultPage();
    const pagesDirectory = usePageDirectory();
    const defaultPage = useDefaultPage(groupId);
    const [value, setValue] = useState(defaultPage?.data);

    const handleOnChange = async (val) => {
        setValue(val);

        const allData = { groupId: groupId, pageId: val };
        await saveDefaultPage.mutateAsync(allData);
        notifyLandingPageSet(pagesDirectory?.data?.modules, val, groupData?.data?.name);
    };

    useEffect(() => {
        setValue(defaultPage?.data);
    }, [defaultPage?.data]);

    if (
        pagesDirectory.isLoading ||
        defaultPage.isLoading ||
        groupData.isLoading
    ) {
        return <>Loading...</>;
    }

    if (pagesDirectory.isError || defaultPage.isError) {
        return <>Error...</>;
    }

    return (
        <VStack>
            <BlockHead
                title="Landing Page"
                description="Select the Page this Access Group will land on when entering to BestWork"
            />

                <VStack spacing="Zero">
                    {pagesDirectory?.data?.modules?.map((d, i) => (
                        <DropdownSingleSelectWithoutSearch
                            key={d.name}
                            value={value}
                            onChange={handleOnChange}
                            options={getDropdownOptions(
                                d.pages,
                                "id",
                                "name",
                                "",
                                ""
                            )}
                            accExpandModeMulti={true}
                            accExpandModeMultiInitialVal={d.pages.some(
                                (s) => s.id === value
                            )}
                            optionVariant={OPTION_VARIANTS.Toggle}
                            isAccordion={true}
                            title={d.name}
                            showIconOnHover={true}
                            showIcon={false}
                            isShowArrow={true}
                            width="18rem"
                        />
                    ))}
                </VStack>
        </VStack>
    );
};

export default AccessGroupLanding;
